import React from 'react';
import OBSOLATE_GameScoreBoard from '../OBSOLATE_GameScoreBoard.js';
import {_GPY,__GPYPost} from '../../../env.js'
import GpyToggleButton from '../lib/GpyToggleButton.js';
import GpyScoreButton from '../lib/GpyScoreButton.js';
import GpyScoreField from '../lib/GpyScoreField.js';
import GpyTeamSelect from '../lib/GpyTeamSelect.js'

import GpyTeamList from '../lib/GpyTeamList.js';
import Display from '../../display/Display.js';
import WaitCube from '../../../WaitCube'
import moment from 'moment';
import 'moment/locale/de';
import OBS from '../../OBS.js'
import Casper from '../../Casper.js'

class SBBowling extends OBSOLATE_GameScoreBoard {

	constructor(props) {

		super(props);
		var s = super.getGPYState("Bowling");
		s.NAME = "Bowling";

		s.currentRound = 1;
		s.dataStore = {};
		s.defaultDataStore = {};

		s.position = [1,{"HOME_TEAM_PLAYER":1,"GUEST_TEAM_PLAYER":1},{"HOME_TEAM_PLAYER":0,"GUEST_TEAM_PLAYER":0}];
		this.state = s;

	}

	componentDidMount() {
		super.getGamesStates();
		super.getGames();
		super.getAdvertisements();
		super.getLayouts();
	}

	initDataStore(id) {
		console.log("INIT:"+id);
		var ds = this.state.dataStore;
		if(ds[id] === undefined){
			var tmp = [];
				tmp.push(0);
			for (var i = 1; i < 13; i++) {
				tmp.push([-1,[-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1],[-1,-1,-1,-1,-1]]);
			}
			ds[id] = {playerId:id, t:tmp};
			this.setState({dataStore:ds});
		}
	}
	toBowlValues(val) {
		var res = JSON.parse(JSON.stringify(val));
		for (var i = 1; i < res.length; i++) {
			var values = res[i];
			if(values[0] === 10) {
				values[0] = "X";
				values[1] = "-";
			}else if( (values[0] + values[1]) === 10) {
				values[1] = "/";
			} else {
				for (var c = 0; c < values.length; c++) {
					if(values[c] === -1) {
						values[c] = "-";
					}
				}
			}
		}
		console.log(res);
		return res;
	}

	setPosition(t,a,b) {
		var pos = this.state.position;
		pos[0] = t;
		pos[1][a.role] = a.pos;
		pos[2][a.role] = a.try;
		super.setState({position:pos,currentRound: t});
	}

	setResult(playerId,val,role) {
console.log("setResult",val);
		var ds = this.state.dataStore;
		if( val >= 0 ) {

				var valIdx = this.state.position[2][role];
				ds[playerId].t[this.state.position[0]][this.state.position[1][role]][valIdx] = val;

				if(valIdx===0) {
					ds[playerId].t[this.state.position[0]][this.state.position[1][role]][1]=-1;
					ds[playerId].t[this.state.position[0]][this.state.position[1][role]][2]=-1;
				} else if(valIdx===1) {
					ds[playerId].t[this.state.position[0]][this.state.position[1][role]][2]=-1;
				}
		}

		this.setState({dataStore:ds},()=>{
			super.storeData();
		//	console.log(this.state.dataStore);
			if(this.state.components.Bowling_player_fullscore!==undefined){
				this.state.components.Bowling_player_fullscore.sendUpdate();
			}
			if(this.state.components.Bowling_single_player_fullscore!==undefined){
				this.state.components.Bowling_single_player_fullscore.sendUpdate();
			}
		});

/*
	var pos = this.state.position;
	if(val>0) {

		if(pos[1] === 10) {
			if(pos[2]<=2){
				pos[2] = pos[2]+1;
			}

		} else {

			if(val===10) {
					pos[1] = pos[1]+1; //toNext Try
			} else if(pos[2]===0) { // to next wurf
				pos[2] = pos[2]+1;
			} else if(pos[2]===1) {
			 	pos[1] = pos[1]+1;
				pos[2] = 0;
			}

		}
	}


		// __GPYPost('setGameState',obj);
		this.setState({result:res,position:pos});
		*/
	 }

	reset() {
 			var res ={112: {playerId:112, t:[new Array(new Array())]} } ;
			res[112].t[1]=[0];
			this.setState({currentRound: 1,position:[1,{"HOME_TEAM_PLAYER":1,"GUEST_TEAM_PLAYER":1},{"HOME_TEAM_PLAYER":0,"GUEST_TEAM_PLAYER":0}], result: res},()=>{
				this.setResult(-1);
			} );
	}



	calcScores(playerId) {

		 var numCk = function(n) {
		 		if(isNaN(n)) {
		 			n = parseInt(n);
		 		}
		 		if(n<0) return 0;
		 		return n;
		 };

	   var r = this.state.dataStore[playerId];
		 if( r === undefined ) return;

		 for(var i = 1; i <= 12 ; i++) {
			 if(r.t[i] !== undefined) {

			   var sum = 0;
				 for(var c = 1;c<=10;c++){

					 if(r.t[i][c] !== undefined) {
						var ar = r.t[i][c];

						if (ar[0] === 10) {  // Strike

												if( c === 10 ) {
															ar[4] = (numCk(ar[0]) + numCk(ar[1]) + numCk(ar[2]));
															console.log("1-AR4",ar[4]);
												} else {

													if(r.t[i][c+1][0] >= 0) {  //nächster wurf > 0
															  console.log("nächster wurf",r.t[i][c+1][0]);
																if(r.t[i][c+1][0]  === 10) {  // auch ein strike
																			console.log("über-nächster wurf",r.t[i][c+2][0]);
																			if( r.t[i][c+2][0] >= 0 ) {
																				ar[4] = (numCk(ar[0]) + numCk(r.t[i][c+1][0]) + numCk(r.t[i][c+2][0]));
																				console.log("2-AR4",ar[4]);
																			} else {
																				ar[4] =  numCk(ar[0]) + numCk(r.t[i][c+1][0]) ;
																				console.log("3-AR4",ar[4]);
																			}
																} else {
																	ar[4] =  numCk(ar[0]) + numCk(r.t[i][c+1][0]) ;
																	console.log("3-AR4",ar[4]);
																}
													} else {
														console.log("4-AR4",ar[4]);
													  ar[4] = 10;
													}

											}

								console.log("AR4",ar[4]);

						} else  if ( (ar[0] + ar[1]) === 10) {  //spare


											if(c===10) {
													ar[4] =  (numCk(ar[0]) + numCk(ar[1]) + (ar[2]>=0?ar[2]:0));
											} else {
												if(r.t[i][c+1][0] >= 0) {
													ar[4] =  (numCk(ar[0]) + numCk(ar[1])) + r.t[i][c+1][0] ;
												} else {
													ar[4] = (numCk(ar[0]) + numCk(ar[1]));
												}

											}



						}	else {

										ar[4] = ( numCk(ar[0]) + numCk(ar[1]) ) <= 0 ?  -1  :  ( numCk(ar[0]) + numCk(ar[1]) );

						}



						if(ar[4] >= 0) {
							sum = parseInt(sum) + parseInt(ar[4]);
 					 		ar[4] = sum;
						}


					 }
				 }

			 	 r.t[i][0] = sum;
				 r.t[0] = sum;
			 }
		 };
	}

	render () {
		const sponsorLogo = this.state.currentGame.sponsorLogo!==undefined&&this.state.currentGame.sponsorLogo!==''?this.state.currentGame.sponsorLogo:"empty.png";
		if(!this.state.defaultValuesLoaded) {
			return (<WaitCube/>);
		}

		var items = [1,2,3,4,5,6,7,8,9,10];
		var rounds = [1,2,3,4,5,6,7,8,9,10,11,12];
		var sc = ["HOME_TEAM_PLAYER","GUEST_TEAM_PLAYER"];

	  return (

			<div>
				<div><h3 className="text-danger">BETA Version</h3></div>
					<div className="row justify-content-end">
						<div className="col-6 text-left p-0"><button onClick={()=>{super.doChangeValue({},"OBS","toggleOBSPanel");}} className="btn btn-link"><img style={{maxWidth : '18px', maxHeight : '18px'}} src={_GPY.resource(this.state.components.OBS!==undefined&&this.state.components.OBS.state.showOBSPanel===true?"images/obs_green.png":"images/obs_black.png")} className="img-fluid" alt=""/></button>
						<button onClick={()=>{super.doChangeValue({},"CasperCG","toggleCasperCGPanel");}} className="btn btn-link"><img style={{maxWidth : '18px', maxHeight : '18px'}} src={_GPY.resource(this.state.components.OBS!==undefined&&this.state.components.OBS.state.showOBSPanel===true?"images/obs_green.png":"images/obs_black.png")} className="img-fluid" alt=""/></button>
						</div>
						<div className="col-6 text-right"><button className="btn btn-link collapsed" type="button" data-toggle="collapse" data-target={"#gametype_"+this.state.NAME+"_scoreboard_games"} aria-expanded="false" aria-controls={"gametype_"+this.state.NAME+"_scoreboard_games"}>
						<span className="text-secondary">
						<span className="glyphicon glyphicon-chevron-down" aria-hidden="true"/>&nbsp;
						{this.state.currentGame.id > 0 ? this.state.currentGame.gameName + " - " + moment(this.state.currentGame.startTime).locale('de').format('L') + " (" + moment(this.state.currentGame.startTime).locale(_GPY.locale).format('HH:mm') + "-"+  moment(this.state.currentGame.endTime).locale(_GPY.locale).format('HH:mm')+ ")":_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_select_game_title')}
						&nbsp;<span className="glyphicon glyphicon-chevron-down" aria-hidden="true"/>
						</span>
						</button></div>
					</div>

					<div className="collapse bg-light" id={"gametype_"+this.state.NAME+"_scoreboard_games"}>
						<div className="row justify-content-center pt-4">
								{this.state.gamesIsLoaded && this.state.games.Games.Game.length>0?
									<div className="col-12 text-center"><h3>{_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_select_game_title')}</h3></div>
								:
									<div className="col-12 text-center"><h3>{_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_select_nogame_title')}</h3></div>
								}

								<div className="col-12 col-sm-12 col-md-8 col-xl-8">
									<div className="list-group">
										 {this.state.gamesIsLoaded ? this.state.games.Games.Game.map((t) => {

											 if( (_GPY.toLocaleMoment(t.endTime) + (1000*60*60)) > _GPY.toLocaleMoment(moment()) )  {

												return (
												<button key={t.id} onClick={()=> {super.onSelectGame(t.id,this.reset())}} className={t.id === this.state.currentGame.id?"list-group-item list-group-item-action list-group-item-success flex-column align-items-start pointer":"list-group-item list-group-item-action flex-column align-items-start pointer"}>
													<div className="row p-2">
													<div className="col-12 text-center"><span>{t.gameName} - {moment(t.startTime).locale('de').format('L')}  ({moment(t.startTime).locale(_GPY.locale).format('HH:mm')} - {moment(t.endTime).locale(_GPY.locale).format('HH:mm')})</span></div>
													</div>
												</button>);
											} else {
												return "";
											}

										 })  : "" }
									</div>
								</div>
						</div>
						<div className="row p-4">
							<div className="col border-top"></div>
							<div className="col-1 text-center text-muted"><span className="glyphicon glyphicon-chevron-down" aria-hidden="true"/><span className="glyphicon glyphicon-chevron-down" aria-hidden="true"/><span className="glyphicon glyphicon-chevron-down" aria-hidden="true"/></div>
							<div className="col border-top"></div>
						</div>
				</div>

		<OBS className="mb-2" scoreboard={this}
					 getTime={ () => {return  this.state.components.SoccerFootball_gameclock!==undefined ? this.state.components.SoccerFootball_gameclock.getSecond() : 0 } }
					 getGameId={() => {return this.state.currentGame.id}} />


			{this.state.currentGame.id > 0 ?
		  	<div>

{/* **************** GAME ****************** */}

<div>

			<div className="row">

					<Casper className="mb-2" scoreboard={this}
					 				 getTime={ () => {return  this.state.components.SoccerFootball_gameclock!==undefined ? this.state.components.SoccerFootball_gameclock.getSecond() : 0 } }
					 				 getGameId={() => {return this.state.currentGame.id}} />
			<div className="col">

				<div className="col-6 pl-4" style={{maxWidth:(this.state.displayWidth+10)+"px"}}>

				 <div className="row">
							<div className="col-9 p-0 border border">
							<select className="form-control"  style={{zIndex:100}} onChange={super.changeLayout.bind(this)} value={this.state.currentLayout.id}>
								<option key="-1" value="-1">default</option>
								{this.state.layoutsIsLoaded ? this.state.layouts.map((t) =>
									<option key={t.id} value={t.id}>{t.name}</option>
								):""}
							</select>
							</div>
							<div className="col-3 p-0 border border">
								<button className="btn btn-outline-dark btn-block" onClick={this.reset.bind(this)}>Reset</button>
							</div>
							<div className="col-12 p-0 border border-white" style={{backgroundColor:"#ff6"}}>
									<Display onData={(data,key)=>{super.onData(key,data);}} width={this.state.displayWidth} height={Math.round(this.state.displayWidth/1.7777777778)} layoutId={this.state.currentLayout.id} stateName="__DISPLAY__" scoreboard={this}/>
							</div>
				</div>
				</div>


				<div className="col-1 pl-4">
					<div className="row">
							<div className="col p-1">
								<GpyToggleButton title={_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_player_fullscore')}
									condition={() => {return (super.playerCountByRole("HOME_TEAM_PLAYER,GUEST_TEAM_PLAYER") === 2 )}}
									onDeactivate={() => {return {visible: false}}}
									onActivate={() => {return {visible: true,
																						home_player : this.state.selectedPlayers["HOME_TEAM_PLAYER"],
																						home_player_name: _GPY.toPlayerName(this.state.selectedPlayers["HOME_TEAM_PLAYER"]),
																						home_score: this.toBowlValues(this.state.dataStore[this.state.selectedPlayers["HOME_TEAM_PLAYER"].id].t[ this.state.currentRound ]),
																						current_round : _GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_fullscore_current_round') + " " + this.state.currentRound,
																						guest_score: this.toBowlValues(this.state.dataStore[this.state.selectedPlayers["GUEST_TEAM_PLAYER"].id].t[this.state.currentRound ]),
																						guest_player : this.state.selectedPlayers["GUEST_TEAM_PLAYER"],
																						guest_player_name: _GPY.toPlayerName(this.state.selectedPlayers["GUEST_TEAM_PLAYER"]),
																					}}}
									scoreboard={this}
									getTime={ () => {return 0;} }
									getGameId={() => {return -1} }
									stateName="Bowling_player_fullscore"
									/>
					  </div>
					</div>

					<div className="row">
							<div className="col p-1">
								<GpyToggleButton title={_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_single_player_fullscore')}
									condition={() => {return (super.playerCountByRole("HOME_TEAM_PLAYER,GUEST_TEAM_PLAYER") === 1 )}}
									onDeactivate={() => {return {visible: false}}}
									onActivate={() => {

													 var team = super.playerCountByRole("HOME_TEAM_PLAYER")===1?"HOME_TEAM_PLAYER":"GUEST_TEAM_PLAYER";
										       return {visible: true,
																						home_player : this.state.selectedPlayers[team],
																						home_player_name: _GPY.toPlayerName(this.state.selectedPlayers[team]),
																						home_score: this.toBowlValues(this.state.dataStore[this.state.selectedPlayers[team].id].t[ this.state.currentRound ]),
																						current_round : _GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_fullscore_current_round') + " " + this.state.currentRound,
																					}}}
									scoreboard={this}
									getTime={ () => {return 0;} }
									getGameId={() => {return -1} }
									stateName="Bowling_single_player_fullscore"
									/>
					  </div>
					</div>
				</div>

				<div className="col pl-4">

									<div className="row">
										<div className="col-6 p-1">
												<strong>{_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_playerlist_home_title')}</strong>
												<GpyTeamList scoreboard={this} game={this.state.currentGame} vsRole="HOME_TEAM_PLAYER" stateName="Bowling_teamlist_home_player"/>
										</div>
										<div className="col-6 p-1">
												<strong>{_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_playerlist_guest_title')}</strong>
												<GpyTeamList scoreboard={this} game={this.state.currentGame} vsRole="GUEST_TEAM_PLAYER" stateName="Bowling_teamlist_guest_player"/>

										</div>
									</div>
     	 </div>
		 </div>



					<div className="row border p-3">
						<div className="col-12"><span>Runde</span></div>

							{ rounds.map( (i) => {
								var buttonClass = "btn btn-sm btn-block border-dark btn-light";
								if((i) === this.state.currentRound){
									var buttonClass = "btn btn-sm btn-block border-dark btn-success";
								}
								return (
									<div className="col-1 p-0 pb-1"><button onClick={()=>{
										sc.map((role)=>{
											this.setPosition(i,{role:role,pos:1,try:0});
										});
									}}  className={buttonClass}>{i}</button></div>
								)
					  	})}

					</div>






{sc.map((role) =>  {
	if(super.playerCountByRole(role)===1){

		this.initDataStore(this.state.selectedPlayers[role].id);
		this.calcScores(this.state.selectedPlayers[role].id);
		console.log(this.state.dataStore,this.state.dataStore[this.state.selectedPlayers[role].id]);

		return(
					<div className="row border p-3">

						<div className="col-12"><span>{_GPY.toPlayerName(this.state.selectedPlayers[role])}</span></div>
						{ items.map( (i) => {
							var buttonClass = "btn btn-sm btn-block border-dark btn-light disabled";
							var maxScore = 10;

							if(this.state.position !== undefined && this.state.position[1][role] === i) {
									if(this.state.position[2][role] === 0) {
								 		buttonClass = "btn btn-sm btn-block border-dark btn-primary";
									} else if(this.state.position[2][role] === 1 ) {

										if(this.state.dataStore!==undefined&&this.state.dataStore[this.state.selectedPlayers[role].id].t[this.state.currentRound]!==undefined&&this.state.dataStore[this.state.selectedPlayers[role].id].t[this.state.currentRound][i]!==undefined){
											maxScore = (10 - this.state.dataStore[this.state.selectedPlayers[role].id].t[this.state.currentRound][i][0]);
										}
										if(i===10) {
											maxScore = 10;
										}
										buttonClass = "btn btn-sm btn-block border-dark btn-success";
									} else if(this.state.position[2][role] === 2 ) {
										maxScore = 10;
										buttonClass = "btn btn-sm btn-block border-dark btn-success";
									}
							}

							return (

							<div className="col-1 border">

								<div className="row">
									<div className="col-12 border-top border-bottom text-center"><span>{i}</span></div>
								</div>
	{this.state.position[1][role]===i?

							<div className="row">
								<div className="col-4 p-0 pb-1"><button onClick={maxScore<1?()=>{}:()=>{this.setResult(this.state.selectedPlayers[role].id,1,role);}} className={buttonClass + (maxScore<1?" disabled":"")}>1</button></div>
								<div className="col-4 p-0 pb-1"><button onClick={maxScore<2?()=>{}:()=>{this.setResult(this.state.selectedPlayers[role].id,2,role);}} className={buttonClass + (maxScore<2?" disabled":"")}>2</button></div>
								<div className="col-4 p-0 pb-1"><button onClick={maxScore<3?()=>{}:()=>{this.setResult(this.state.selectedPlayers[role].id,3,role);}} className={buttonClass + (maxScore<3?" disabled":"")}>3</button></div>

								<div className="col-4 p-0 pb-1"><button onClick={maxScore<4?()=>{}:()=>{this.setResult(this.state.selectedPlayers[role].id,4,role);}} className={buttonClass + (maxScore<4?" disabled":"")}>4</button></div>
								<div className="col-4 p-0 pb-1"><button onClick={maxScore<5?()=>{}:()=>{this.setResult(this.state.selectedPlayers[role].id,5,role);}} className={buttonClass + (maxScore<5?" disabled":"")}>5</button></div>
								<div className="col-4 p-0 pb-1"><button onClick={maxScore<6?()=>{}:()=>{this.setResult(this.state.selectedPlayers[role].id,6,role);}} className={buttonClass + (maxScore<6?" disabled":"")}>6</button></div>

								<div className="col-4 p-0 pb-1"><button onClick={maxScore<7?()=>{}:()=>{this.setResult(this.state.selectedPlayers[role].id,7,role);}} className={buttonClass + (maxScore<7?" disabled":"")}>7</button></div>
								<div className="col-4 p-0 pb-1"><button onClick={maxScore<8?()=>{}:()=>{this.setResult(this.state.selectedPlayers[role].id,8,role);}} className={buttonClass + (maxScore<8?" disabled":"")}>8</button></div>
								<div className="col-4 p-0 pb-1"><button onClick={maxScore<9?()=>{}:()=>{this.setResult(this.state.selectedPlayers[role].id,9,role);}} className={buttonClass + (maxScore<9?" disabled":"")}>9</button></div>
								<div className="col-6 p-0 pb-1"><button onClick={maxScore<10?()=>{}:()=>{this.setResult(this.state.selectedPlayers[role].id,10,role);}} className={buttonClass + (maxScore<10?" disabled":"")}>10</button></div>
								<div className="col-6 p-0 pb-1"><button onClick={maxScore<0?()=>{}:()=>{this.setResult(this.state.selectedPlayers[role].id,0,role);}} className={buttonClass + (maxScore<0?" disabled":"")}>0</button></div>

							</div>
	 :

						 <div className="row">
					 		<div className="col-4 p-0 pb-1"><button className={buttonClass}>1</button></div>
					 		<div className="col-4 p-0 pb-1"><button className={buttonClass}>2</button></div>
					 		<div className="col-4 p-0 pb-1"><button className={buttonClass}>3</button></div>

					 		<div className="col-4 p-0 pb-1"><button className={buttonClass}>4</button></div>
					 		<div className="col-4 p-0 pb-1"><button className={buttonClass}>5</button></div>
					 		<div className="col-4 p-0 pb-1"><button className={buttonClass}>6</button></div>

					 		<div className="col-4 p-0 pb-1"><button className={buttonClass}>7</button></div>
					 		<div className="col-4 p-0 pb-1"><button className={buttonClass}>8</button></div>
					 		<div className="col-4 p-0 pb-1"><button className={buttonClass}>9</button></div>
					 		<div className="col-6 p-0 pb-1"><button className={buttonClass}>10</button></div>
							<div className="col-6 p-0 pb-1"><button className={buttonClass}>0</button></div>

					 	</div>
 }
	 {i==10?

								<div className="row">
									<div className="col-4 p-0 border-right text-center"><button onClick={()=>{this.setPosition(this.state.currentRound,{role:role,pos:i,try:0});}} className="btn btn-sm btn-block btn-primary">{this.state.dataStore!==undefined&&this.state.dataStore[this.state.selectedPlayers[role].id].t[this.state.currentRound]!==undefined&&this.state.dataStore[this.state.selectedPlayers[role].id].t[this.state.currentRound][i]!==undefined&&this.state.dataStore[this.state.selectedPlayers[role].id].t[this.state.currentRound][i][0]>=0?this.state.dataStore[this.state.selectedPlayers[role].id].t[this.state.currentRound][i][0]:<span class="glyphicon glyphicon-plus-sign" aria-hidden="true"/>}</button></div>
									<div className="col-4 p-0 border-bottom text-center"><button onClick={()=>{this.setPosition(this.state.currentRound,{role:role,pos:i,try:1});}} className="btn btn-sm btn-block btn-success">{this.state.dataStore!==undefined&&this.state.dataStore[this.state.selectedPlayers[role].id].t[this.state.currentRound]!==undefined&&this.state.dataStore[this.state.selectedPlayers[role].id].t[this.state.currentRound][i]!==undefined&&this.state.dataStore[this.state.selectedPlayers[role].id].t[this.state.currentRound][i][1]>=0?this.state.dataStore[this.state.selectedPlayers[role].id].t[this.state.currentRound][i][1]:<span class="glyphicon glyphicon-plus-sign" aria-hidden="true"/>}</button></div>
									<div className="col-4 p-0 border-bottom text-center"><button onClick={()=>{this.setPosition(this.state.currentRound,{role:role,pos:i,try:2});}} className="btn btn-sm btn-block btn-success">{this.state.dataStore!==undefined&&this.state.dataStore[this.state.selectedPlayers[role].id].t[this.state.currentRound]!==undefined&&this.state.dataStore[this.state.selectedPlayers[role].id].t[this.state.currentRound][i]!==undefined&&this.state.dataStore[this.state.selectedPlayers[role].id].t[this.state.currentRound][i][2]>=0?this.state.dataStore[this.state.selectedPlayers[role].id].t[this.state.currentRound][i][2]:<span class="glyphicon glyphicon-plus-sign" aria-hidden="true"/>}</button></div>
									<div className="col-12 text-center"><span>{this.state.dataStore!==undefined&&this.state.dataStore[this.state.selectedPlayers[role].id].t[this.state.currentRound]!==undefined&&this.state.dataStore[this.state.selectedPlayers[role].id].t[this.state.currentRound][i]!==undefined&&this.state.dataStore[this.state.selectedPlayers[role].id].t[this.state.currentRound][i][4]>=0?this.state.dataStore[this.state.selectedPlayers[role].id].t[this.state.currentRound][i][4]:"-"}</span></div>
								</div>
		:
								<div className="row">

									<div className="col-6 p-0 border-right text-center">
									<button onClick={()=>{this.setPosition(this.state.currentRound,{role:role,pos:i,try:0});}} className="btn btn-sm btn-block btn-primary">
									{this.state.dataStore!==undefined&&this.state.dataStore[this.state.selectedPlayers[role].id].t[this.state.currentRound]!==undefined&&this.state.dataStore[this.state.selectedPlayers[role].id].t[this.state.currentRound][i]!==undefined&&this.state.dataStore[this.state.selectedPlayers[role].id].t[this.state.currentRound][i][0]>=0?this.state.dataStore[this.state.selectedPlayers[role].id].t[this.state.currentRound][i][0]:<span class="glyphicon glyphicon-plus-sign" aria-hidden="true"/>}
									</button></div>

									<div className="col-6 p-0 border-bottom text-center">
									<button onClick={()=>{this.setPosition(this.state.currentRound,{role:role,pos:i,try:1});}} className="btn btn-sm btn-block btn-success">
									{this.state.dataStore!==undefined&&this.state.dataStore[this.state.selectedPlayers[role].id].t[this.state.currentRound]!==undefined&&this.state.dataStore[this.state.selectedPlayers[role].id].t[this.state.currentRound][i]!==undefined&&this.state.dataStore[this.state.selectedPlayers[role].id].t[this.state.currentRound][i][1]>=0?this.state.dataStore[this.state.selectedPlayers[role].id].t[this.state.currentRound][i][1]:<span class="glyphicon glyphicon-plus-sign" aria-hidden="true"/>}
									</button></div>

									<div className="col-12 text-center"><span>{this.state.dataStore!==undefined&&this.state.dataStore[this.state.selectedPlayers[role].id].t[this.state.currentRound]!==undefined&&this.state.dataStore[this.state.selectedPlayers[role].id].t[this.state.currentRound][i]!==undefined&&this.state.dataStore[this.state.selectedPlayers[role].id].t[this.state.currentRound][i][4]>=0?this.state.dataStore[this.state.selectedPlayers[role].id].t[this.state.currentRound][i][4]:"-"}</span></div>
								</div>
		}
							</div>
							);
						})}

					<div className="col-1 border">
						<div className="row">
							<div className="col-12 border-bottom text-center"><span>Score</span></div>
							<div className="col-12 text-center"><span>
							{this.state.dataStore!==undefined&&this.state.dataStore[this.state.selectedPlayers[role].id]!==undefined&&this.state.dataStore[this.state.selectedPlayers[role].id].t!==undefined?this.state.dataStore[this.state.selectedPlayers[role].id].t[this.state.currentRound ][0]:"-"}
							</span></div>
						</div>
					</div>


				<div className="col-1 border">
					<div className="row">
					{/*
						<div className="col-12 border-bottom text-center"><span>Max Possible</span></div>
						<div className="col-12 text-center"><span>{300-score}</span></div>
					*/}
					</div>
				</div>


			{/*
				<div className="col-12 p-5 text-center"><h2>{this.props.toString()} : coming soon</h2></div>
				<div className="col-12 p-5 text-center"><button onClick={()=>{this.props.setGameType("Dashboard")}} className="btn btn-secondary">Dashboard</button></div>
				*/}


			</div>

		);
}})}

		</div>

			</div>



{/* **************** GAME ****************** */}



				 </div>

			 :<div>{_GPY.i18n.get('gametype_'+this.state.NAME+'_scoreboard_warn_message_selectgame')}</div>}

 		</div>
		);
    }

}
export default SBBowling;
